import{getSlotType} from "@/api/select"

const slotType={}
let slotTypeList=[]

getSlotType().then(res=>{
  let list=res.data
  list.forEach(item => {
    slotType[item.slotTypeId]=item.slotTypeName
    slotTypeList.push({
      label:item.slotTypeName,
      value:item.slotTypeId
    })
  });
})
export const slotTypeMap=slotType
export default slotTypeList
